import { t } from '@/i18n/utils'

/**
 * 历史记录页面通用配置
 * 当前三端（rocnovel、oceread、ficmoon）文案一致
 */
export const historyCommonConfig = {
  texts: {
    get noData() { return t('NoData') },
    get goToNovel() { return t('GoToNovel') },
    get viewed() { return t('ViewedTab') },
    get completed() { return t('Completed') },
    get ongoing() { return t('OnGoing') },
    get lastRead() { return t('LastRead') },
    // 与 en.json 不完全匹配（逗号前有空格差异）
    get noMore() { return t('noMore') },
    get loading() { return `${t('Loading')}...` },
    get bookRemoved() { return t('BookRemoved') },
    get favoritesTab() { return t('FavoritesTab') },
    get historyTab() { return t('HistoryTab') },
    get play() { return t('PlayButton') },
    get continueText() { return t('Continue') },
    chapterOf(no: number, total?: number) {
      return total ? t('ChapterOf', { no, total }) : t('ChapterNo', { no })
    },
    episodeOf: (ep: number | string, total: number | string) => t('dramaEpisodeOf', { ep, total }),
  },
}
